module.exports = __webpack_public_path__ + "img/icon_happy_logo.e87c50af.png";